/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleExecutionParameterForTemplateOciProvider extends models.ScheduleExecutionParameterForTemplateBase {
    constructor() {
        super();
        this.setDiscriminator("ScheduleExecutionParameterForTemplateOciProvider");
    }

    getFixupPrototypeFunction() { return ScheduleExecutionParameterForTemplateOciProvider.fixupPrototype; }

    static newInstance(model: Partial<ScheduleExecutionParameterForTemplateOciProvider>): ScheduleExecutionParameterForTemplateOciProvider {
        let obj = Object.assign(new ScheduleExecutionParameterForTemplateOciProvider(), model);
        ScheduleExecutionParameterForTemplateOciProvider.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleExecutionParameterForTemplateOciProvider>): ScheduleExecutionParameterForTemplateOciProvider {
        if (!model) return null;
        return ScheduleExecutionParameterForTemplateOciProvider.newInstance(<ScheduleExecutionParameterForTemplateOciProvider> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleExecutionParameterForTemplateOciProvider) {
        if (!obj) return;

        models.ScheduleExecutionParameterForTemplateOciProvider.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleExecutionParameterForTemplateOciProvider): boolean {
        if (models.ScheduleExecutionParameterForTemplateBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleExecutionParameterForTemplateOciProvider.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * The region of the cloud account where it needs to be executed.
     */
    region: string;

    /**
     * The compartment for which you need to execute the template for.
     */
    compartment: string;

}
